import React, { useRef, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { FaWhatsapp, FaFacebook, FaEnvelope } from 'react-icons/fa';
import { useParams } from 'react-router-dom';

const QRCodeAgent = () => {
  const { agentId } = useParams();
  const [qrUrl] = useState(`https://keurgui-backend-kjour.ondigitalocean.app/#/agent-properties/${agentId}`);
  const qrRef = useRef(null);

  const downloadImage = async () => {
    const canvas = await html2canvas(qrRef.current);
    const image = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = image;
    link.download = 'qrcode-propriete.png';
    link.click();
  };

  const downloadPDF = async () => {
    const canvas = await html2canvas(qrRef.current);
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF();
    pdf.addImage(imgData, 'PNG', 20, 20, 170, 170);
    pdf.save('qrcode-propriete.pdf');
  };

  return (
    <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
      <div
        className="rounded-4 border p-4"
        style={{
          background: '#fefbe9',
          maxWidth: 900,
          boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
        }}
      >
        <div className="row align-items-center g-4">
          {/* QR code */}
          <div className="col-12 col-md-6 d-flex justify-content-center">
            <div className="bg-white p-3 rounded-3" ref={qrRef}>
              <QRCodeSVG value={qrUrl} size={260} level="H" includeMargin={true} />
            </div>
          </div>
          {/* Bloc à droite */}
          <div className="col-12 col-md-6 d-flex flex-column align-items-center align-items-md-start">
            <h2 className="fw-bold mb-2 text-dark text-center text-md-start" style={{ fontSize: '2.2rem', marginTop: 12 }}>
              Partagez votre QR Code
            </h2>
            <p className="mb-4 text-dark fs-5 text-center text-md-start" style={{ maxWidth: 350 }}>
              Vous pouvez télécharger ce QR Code et l'afficher dans votre restaurant.
            </p>
            <div className="w-100 mb-4" style={{ maxWidth: 340 }}>
              <button
                className="btn btn-success w-100 mb-3 fs-5 fw-semibold"
                style={{ background: '#15cf7b', border: 'none' }}
                onClick={downloadPDF}
              >
                Télécharger PDF
              </button>
              <button
                className="btn btn-primary w-100 fs-5 fw-semibold"
                style={{ background: '#0a7cff', border: 'none' }}
                onClick={downloadImage}
              >
                Télécharger l'image
              </button>
            </div>
            <div className="d-flex gap-4 mt-3 justify-content-center justify-content-md-start w-100 fs-2">
              <a
                href={`https://wa.me/?text=${encodeURIComponent(`Découvrez cette propriété : ${qrUrl}`)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-success"
                title="Partager via WhatsApp"
              >
                <FaWhatsapp />
              </a>
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(qrUrl)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary"
                title="Partager sur Facebook"
              >
                <FaFacebook />
              </a>
              <a
                href={`mailto:?subject=Découvrez cette propriété&body=Voici le lien vers la propriété : ${qrUrl}`}
                className="text-danger"
                title="Partager par email"
              >
                <FaEnvelope />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRCodeAgent;